export default __webpack_public_path__ + "static/media/mascote-cabeca.fe851511.webp";